module.exports = {
    title:"Book Recommendations",
    description: "Book recommendations by famous entrepreneurs, founders, authors, venture capitalists, product managers, UX designers and technological visionaries",
}